import React from 'react';
import { useTheme } from '@mui/material';
import { VTypography } from '@venti-components';
import { CARD_TYPES } from '../../../../constants/types';

const CardType = ({ cardType }) => {
  const theme = useTheme();

  if (!cardType) {
    return null;
  }

  const getCardTypeText = () => {
    switch (cardType) {
      case CARD_TYPES.CREDIT:
        return ' ‧ Sólo crédito';
      case CARD_TYPES.DEBIT:
        return ' ‧ Sólo débito';
      default:
        return null;
    }
  };

  const cardTypeText = getCardTypeText();

  if (!cardTypeText) {
    return null;
  }

  return (
    <VTypography variant="body2" color={theme.palette.text.secondary}>
      {cardTypeText}
    </VTypography>
  );
};

export default CardType;
